export const withHost = (url) => `${process.env.REACT_APP_HOST}${url}`;
